/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export interface Error {
  timestamp: number;
  requestId: string;
  status: number;
  error: any;
  message: string;
  path: string;
}
